<template>
  <v-dialog v-model="popupData.show" width="300" color="white">
    <v-card class="px-3 py-3">
      
      <slot name="message"></slot>
      <v-btn
        block
        color="error"
        @click="ok()"
        class="font-weight-bold text-capitalize"
      >
        {{okText || 'Ok'}}
      </v-btn>
      <v-btn v-if="!hideCancel"
        style="color:#ff5252"
        block
        text
        @click="close()"
        class="font-weight-bold text-capitalize mt-2"
      >
        {{noText || 'No'}}
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Alert",
  props: ["popupData", "hideCancel", "okText", "noText"],
  mounted: function() {
    console.log("cnfpopopp", this.popupData);
  },
  methods: {
    ok: function() {
      this.$emit("ok");
    },
    close: function() {
      this.$emit("closed");
    }
  }
}
</script>